import { render, staticRenderFns } from "./JsmTablePagination.vue?vue&type=template&id=783ad39d&"
import script from "./JsmTablePagination.vue?vue&type=script&lang=js&"
export * from "./JsmTablePagination.vue?vue&type=script&lang=js&"
import style0 from "./JsmTablePagination.styl?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports